export { default, Props } from './InformationDialog';
